import { defineRule } from 'vee-validate'
import {
  required,
  email,
  min_value,
  between,
  numeric,
  min,
  max,
  length,
  digits,
  integer,
  alpha_num,
} from '@vee-validate/rules'

export default defineNuxtPlugin(() => {
  defineRule('alpha_num', alpha_num)
  defineRule('email', email)
  defineRule('required', required)
  defineRule('min_value', min_value)
  defineRule('between', between)
  defineRule('numeric', numeric)
  defineRule('min', min)
  defineRule('max', max)
  defineRule('length', length)
  defineRule('digits', digits)
  defineRule('integer', integer)

  defineRule('greater', (value: any, [target]: any[]) => {
    return value > target || '{_field_} must be greater than {target}'
  })

  defineRule('timeStartFinish', (value: any, [target]: any[]) => {
    return value > target || '{_field_} must be later than {target}'
  })

  defineRule('password', (value: any, [target]: any[]) => {
    return value === target || 'Password confirmation does not match'
  })

  defineRule('pin', (value: any, [target]: any[]) => {
    return value === target || 'Pin confirmation does not match'
  })

  defineRule('currency', (value: any) => {
    const regex = /\d{0,2}(\.\d{1,2})?/
    return regex.test(value) || '{_field_} is not a valid amount'
  })

  defineRule('noCurrencyOrBrackets', (value: any) => {
    const regex = /[\p{Sc}[\](){}]/u
    return !regex.test(value) || 'This title contains special characters that may prevent it from being shown in Google Search & Maps'
  })

  defineRule('facebook', (value: any) => {
    const regex = /^[a-zA-Z0-9.-]+$/
    return regex.test(value) || 'Invalid Facebook ID'
  })

  defineRule('instagram', (value: any) => {
    const regex = /^([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)$/
    return regex.test(value) || 'Invalid Instagram username'
  })

  defineRule('twitter', (value: any) => {
    const regex = /^[a-zA-Z0-9]([a-zA-Z0-9_]{0,14})$/
    return regex.test(value) || 'Invalid Twitter handle'
  })

  defineRule('pinterest', (value: any) => {
    const regex = /^[a-zA-Z0-9._-]{3,30}$/
    return regex.test(value) || 'Invalid Pinterest username'
  })

  defineRule('tiktok', (value: any) => {
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9._]{1,23}$/
    return regex.test(value) || 'Invalid TikTok username'
  })

  defineRule('whatsapp', (value: any) => {
    const regex = /^[a-zA-Z0-9+/]+={0,2}$/
    return regex.test(value) || 'Invalid WhatsApp channel ID'
  })

  defineRule('youtube', (value: any) => {
    const regex = /^[a-zA-Z0-9_.-]{3,30}$/
    return regex.test(value) || 'Invalid YouTube handle'
  })

  defineRule('linkedin', (value: any) => {
    const regex = /^[a-zA-Z0-9_-]{5,30}$/
    return regex.test(value) || 'Invalid LinkedIn name'
  })

  defineRule('reddit', (value: any) => {
    const regex = /^[a-zA-Z0-9_]{3,20}$/
    return regex.test(value) || 'Invalid Reddit username'
  })

  defineRule('threads', (value: any) => {
    const regex = /^[a-zA-Z][a-zA-Z0-9_.]{0,29}$/
    return regex.test(value) || 'Invalid Threads username'
  })

  defineRule('linktree', (value: any) => {
    const regex = /^[a-zA-Z0-9_.]{1,30}$/
    return regex.test(value) || 'Invalid Linktree username'
  })
})
